<template>
  <div class="container">
    <img class="bg_mobile" v-if="isMobile" alt="" :src="`${$cdn}images/mobile/index_mbg.jpg`">
    <img class="bg_img" v-else :src="`${$cdn}images/index_bg.jpg`" alt="">

    <audio
      class="audio"
      id="audio1"
      :src="`${$cdn}audio/jiangjie.mp3`"
      preload
      loop
      ref="musicBg"
    ></audio>


    <div class="introduce">
      <h1 v-if="!openIntro" @click="openIntro=!openIntro">三亚国际免税城旅游区
        <img :src="`${$cdn}images/icon_scene_tit_arrow@2x.png`" alt="">
      </h1>

      <div class="open" v-else @click="openIntro=!openIntro">
        <span >三亚国际免税城旅游区</span><img :src="`${$cdn}images/icon_scene_tit_arrow@2xtop.png`" alt="">
        <p @click.stop class="intro">三亚国际免税城旅游区位于海南省三亚市国家海岸海棠湾内，是集免税购物、有税购物、餐饮娱乐、文化展示、旅游休闲于一身的国际化综合度假目的地，是中、高端旅游者必游的海南景点。</p>
      </div>
    </div>

    <div class="logo" v-if="!isMobile">
        <img :src="`${$cdn}images/index_logo@2x.png`" alt />
    </div>

    <div class="map">
        <img @click="$intro({type:'map'})" :src="`${$cdn}images/maps_01@2x.png`" alt />
    </div>

    <ul class="aside">
      <li @click="handleItem(item)" v-for="(item,i) in aside" :key="i" class>
         <img v-if="item.id === 'jiangjie' && musicSta" :src="`${$cdn}images/aside/nav_02_stop@2x.png`" alt="">
        <img v-else :src="`${$cdn}images/aside/${item.name}.png`" alt />
      </li>
    </ul>

    <div class="home_btn" >
        <img @click="enter" :src="`${$cdn}images/index_enter@2x.png`" alt />
    </div>
  </div>
</template>

<script>
import browser from '@/utils/browser'

const aside = [
  {
    id: "guanwang",
    name: "nav_01@2x"
  },
  {
    id: "jiangjie",
    name: "nav_02@2x"
  },
  {
    id: "jianjie",
    name: "nav_03@2x"
  },
  {
    id: "msq",
    name: "nav_04@2x"
  },
  {
    id: "hxd",
    name: "nav_05@2x"
  }
];
export default {
  name: "Home",
  data() {
    return {
      openIntro:false,
      active: false,
      aside,
      listVisable: false,
      detailVisable: false,
      activeType: "",
      isMobile: browser.mobile,
      activeDetail: "",
      musicSta: false,
      mus: ""
    };
  },
  watch: {
    musicSta(val) {
      val ? this.$refs.musicBg.play() : this.$refs.musicBg.pause();
    }
  },
  computed: {
    ifr() {
      let { ifr } = this.$route.query;
      let iframe = ifr ? ifr : "https://houseoss.4dkankan.com/syms/panorama/msmk/tour.html";
      return iframe;
    },
    titleImg() {
      let { ifr } = this.$route.query;

      return !ifr
        ? `${this.$cdn}title/FKQAD.png`
        : ``;
    }
  },

  methods: {
    enter(){
      this.$router.push({path:'/list'})
      this.$emit('audio',true)
    },
    handleMsgs(data) {
      this.detailVisable = true;
      this.activeDetail = data.item;
    },
    handleItem(item) {
      
      if (item.id === "jianjie") {
        this.$intro({type:'intro'})
      }

       if (item.id === "msq") {
        this.$intro({type:'msq'})
      }

      if (item.id === "hxd") {
        this.$intro({type:'hxd'})
      }

      if (item.id === "guanwang") {
        return  window.location.href = 'http://www.cdfgsanya.com'
      }
      if (item.id === "jiangjie") {
        this.musicSta = !this.musicSta
      }
      this.listVisable = true;
      this.activeType = item.name;
    }
  },
  mounted() {
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  .audio {
    position: fixed;
    top: -100px;
    left: -100px;
    opacity: 0;
  }
  .bg_img{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 100%;
    z-index: -1;
  }
  .bg_mobile{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    height: 100%;
    z-index: -1;
  }

  .introduce{
    position: absolute;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
    h1{
      color: #fff;
      letter-spacing: 1px;
      font-size: 18px;
      font-weight: normal;
      line-height: 48px;
      height: 48px;
      min-width: 390px;
      text-align: center;
      position: relative;
      background: linear-gradient(89deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 29%, rgba(0, 0, 0, 0.2) 69%, rgba(0, 0, 0, 0) 100%);
      img{
        position: absolute;
        width: 12px;
        right: 110px;
        top: 50%;
        transform: translateY(-50%);
        left: unset;
      }
    }
    .open{
      text-align: center;
      border: 2px solid rgba(255, 255, 255, 0.3);
      width: 200px;
      line-height: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 20px;
      color: #fff;
      position: relative;
       img{
        position: absolute;
        width: 14px;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
        left: unset;
      }
      .intro{
        background: rgba(0, 0, 0, 0.5);
        border-radius: 4px;
        width: 280px;
        position: absolute;
        padding: 14px 16px;
        line-height: 1.5;
        text-align: justify;
        font-size: 14px;
        top: 48px;
        cursor: auto;
      }
    }
  }

  .logo{
    position: absolute;
    top: 30px;
    left: 30px;
    img{
      width: 224px;
    }
  }

  .map{
    position: absolute;
    top: 100px;
    right: 30px;
    img{
      cursor: pointer;
      width: 100px;
    }
  }

  .home_btn{
    position: absolute;
    bottom: 100px;
    left: 50%;
    transform: translateX(-50%);
    img{
      cursor: pointer;
      width: 176px;
    }
  }
 
  .aside {
    position: fixed;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
    li {
      cursor: pointer;
      margin-top: 20px;
      img {
        width: 64px;
      }
    }
  }

}
@media screen and (max-width: 500px) {
  .container {
    max-width: 500px;
    .introduce{
      z-index: 999;
      top: 10px;
      h1{
        min-width: 310px;
        line-height: 40px;
        height: 40px;
        img{
          position: absolute;
          width: 12px;
          right: 60px;
          transform: translateY(-50%);
          left: unset;
        }
      }
    }
    .map{
      top: 70px;
      right: 20px;
      img{
        width: 90px;
      }
    }
    .aside {
      top: 180px;
      transform: translateY(0);
      right: 20px;
      li {
        margin-top: 15px;
        img {
          width: 44px;
        }
      }
    }

    .home_btn{
      bottom: 64px;
      img{
        width: 144px;
      }
    }
  }
}
</style>